module.exports = __webpack_public_path__ + "img/hyundai_thumbnail.e6f9e284.png";